import { z } from 'zod';
import { UUIDSchema } from './common';
export const CostCenterSchema = z.object({
    uuid: UUIDSchema,
    name: z.string(),
    description: z.string().optional(),
});
